import styled from 'styled-components';
import { IconButton } from '../IconButton';
import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';

export const SearchContainer = styled.div`
  display: flex;
  ${whiteTheme.media.tabletS} {
  }
  ${whiteTheme.media.tablet} {
  }
  ${whiteTheme.media.mobileM} {
  }
`;

export const StyledIconButton = styled(IconButton)`
  display: flex;
  align-items: center;
  width: 17px;
  height: 17px;
  margin-left: 7.5px;
  margin-right: 7.5px;
  & > div:first-child {
    width: 17px;
    min-width: 17px;
    height: 17px;
  }
  ${whiteTheme.media.tabletS} {
    margin-left: 5px;
    margin-right: 5px;
  }
  ${whiteTheme.media.tablet} {
    margin-left: 0;
    margin-right: 0;
    position: fixed;
    top: 35px;
    right: 17px;
    z-index: 1004;
  }
  ${whiteTheme.media.mobileM} {
    top: 26px;
    & div {
    }
  }
`;
